<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'

    @Component({})
    export class TourAdditionalInfo extends Vue {
        @Prop({required: true}) info

        render() {
            return null
        }
    }

    export default TourAdditionalInfo
</script>
